<template>
  <div class="centered">

  <div id="login_page" v-if="!show_step_b">
    <h1>כניסה לכנס פסגת הנדל"ן</h1>

    <form @submit.prevent="login()">
      <input type="number" name="phone" placeholder="מספר טלפון" ref="phone" required="">
      <div><input type="submit" value="הכנס" class="btn"></div>
    </form>
  </div>
  
  <div id="login_page" v-if="show_step_b">
    <h1>כניסה לכנס פסגת הנדל"ן</h1>
    <h3>אנא הזן את הקוד שקיבלת כעת למכשירך</h3>
    <form @submit.prevent="login_confirm()">
      <input type="number" name="code" placeholder="קוד" ref="code" required="">
      <div><input type="submit" value="הכנס" class="btn"></div>
    </form>
  </div>
</div>
      

</template>


<script>
export default {
  props: ["widgets", "item"],
  data(){
      return {
        token: '',
        show_step_b: false
      }
  },
  created(){
    
    
  },
  methods:{
    login()
    {
      var self = this;
      this.api_call({ url: 'login_phone', data:  {phone: this.$refs.phone.value}, onComplete: function(data){

          if (data.data.data != false)
          {
            self.token = data.data.data;
            self.show_step_b = true;
          }
          else alert('פרטי ההתחברות אינם נכונים.');
        }});
    },
    login_confirm()
    {
     // var self = this;
      this.api_call({ url: 'login_confirm', data:  {code: this.$refs.code.value, token: this.token}, onComplete: function(data){

          if (data.data.data != false)
          {
            localStorage.setItem('user_token', data.data.data);
            document.location = '/';
          }
          else alert('פרטי ההתחברות אינם נכונים.');
        }});
    }
  }
}
</script>